export function initializeNavMenu() {
	// Toggle nav menu when the main menu button is clicked
	const menuToggle = document.querySelector('.menu-toggle');

	if (menuToggle) {
		menuToggle.addEventListener('click', function (e) {
			e.stopPropagation(); // Prevent event from bubbling up
			e.preventDefault(); // Prevent default link/button behavior
			this.classList.toggle('active'); // Toggle "active" state for the button
			document.querySelector('.dash-main').classList.toggle('nav-opened'); // Toggle body wrapper shift
			document.querySelector('.dash-nav').classList.toggle('active'); // Toggle nav menu visibility
		});
	}

	// Toggle nav menu when the mobile menu button is clicked
	const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
	if (mobileMenuToggle) {
		mobileMenuToggle.addEventListener('click', function (e) {
			e.preventDefault(); // Prevent default behavior
			document.querySelector('.menu-toggle').classList.toggle('active'); // Sync main toggle button state
			document.querySelector('.dash-main').classList.toggle('nav-opened'); // Toggle wrapper shift
			document.querySelector('.dash-nav').classList.toggle('active'); // Toggle nav menu visibility
		});
	}



	// Close nav menu when clicking outside of it
	document.addEventListener('click', function (e) {
		const dashNav = document.querySelectorAll('.dash-nav');
		if (dashNav) {
			dashNav.forEach(menu => {
				if (!menu.contains(e.target)) { // If the click is outside the nav
					menu.classList.remove('active'); // Hide nav
					document.querySelector('.menu-toggle').classList.remove('active'); // Reset button state
					document.querySelector('.dash-main').classList.remove('nav-opened'); // Reset wrapper shift
				}
			});
		}
	});
}